import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthSelectors } from '../../store';
import { switchMap, first } from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class BodyInterceptor implements HttpInterceptor {
    constructor(
        private authSelector: AuthSelectors
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const handleMethods = ['POST', 'PATCH'];
        if (handleMethods.indexOf(req.method) === -1) {
            return next.handle(req);
        }
        return this.authSelector.userIds$.pipe(
            first(),
            switchMap(userids => {
                const newBody = req.clone().body;
                if (newBody && typeof newBody === 'object') {
                    this.setKey(newBody, 'cb', userids.userName);
                    this.setKey(newBody, 'kontor', userids.officeId);
                    this.setKey(newBody, 'bruger', userids.userId);
                    this.setKey(newBody, 'officeId', userids.officeId);
                    this.setKey(newBody, 'userId', userids.userId);
                }
                const newReq = req.clone({body: newBody});
                return next.handle(newReq);
            })
        );
    }

    setKey(body: Object, prop: string, value: number | string | Date) {
        if (body.hasOwnProperty(prop) && body[prop] === undefined) {
            body[prop] = value;
        }
    }

}
